import { render } from "./AccessHandledRouterLink.vue?vue&type=template&id=27861e18"
import script from "./AccessHandledRouterLink.vue?vue&type=script&lang=js"
export * from "./AccessHandledRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AccessHandledRouterLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27861e18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27861e18', __exports__)) {
    api.reload('27861e18', __exports__)
  }
  
  module.hot.accept("./AccessHandledRouterLink.vue?vue&type=template&id=27861e18", () => {
    api.rerender('27861e18', render)
  })

}


export default __exports__